import React from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {useP2cRoutes} from '../modules/p2c/Routes'
import {useUsersRoutes} from '../modules/core/Routes'
import useAnalyticsRoutes from '../modules/analytics/AnalyticsRouter';

const PrivateRoutes = () => {
  const p2cRoutes = useP2cRoutes()
  const usersRoutes = useUsersRoutes()
  const analyticsRoutes = useAnalyticsRoutes();

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/p2c/dashboard' />} />
        {/* Pages */}
        {analyticsRoutes}

        {p2cRoutes}

        {usersRoutes}

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export {PrivateRoutes}
